var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#FEF6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0007 19C15.0007 17.1435 15.7382 15.363 17.0509 14.0503C18.3637 12.7375 20.1441 12 22.0007 12C23.8572 12 25.6377 12.7375 26.9504 14.0503C28.2632 15.363 29.0007 17.1435 29.0007 19V22.764L30.8227 26.408C30.9065 26.5757 30.9461 26.7621 30.9377 26.9494C30.9293 27.1368 30.8731 27.3188 30.7745 27.4783C30.6759 27.6379 30.5382 27.7695 30.3744 27.8608C30.2106 27.9521 30.0262 28 29.8387 28H25.8747C25.6522 28.8582 25.1511 29.6183 24.4499 30.1609C23.7488 30.7035 22.8873 30.9979 22.0007 30.9979C21.1141 30.9979 20.2526 30.7035 19.5514 30.1609C18.8502 29.6183 18.3491 28.8582 18.1267 28H14.1627C13.9751 28 13.7907 27.9521 13.6269 27.8608C13.4631 27.7695 13.3254 27.6379 13.2268 27.4783C13.1282 27.3188 13.072 27.1368 13.0636 26.9494C13.0552 26.7621 13.0948 26.5757 13.1787 26.408L15.0007 22.764V19ZM20.2687 28C20.4442 28.304 20.6967 28.5565 21.0007 28.732C21.3047 28.9075 21.6496 28.9999 22.0007 28.9999C22.3517 28.9999 22.6966 28.9075 23.0006 28.732C23.3046 28.5565 23.5571 28.304 23.7327 28H20.2687ZM22.0007 14C20.6746 14 19.4028 14.5268 18.4651 15.4645C17.5274 16.4021 17.0007 17.6739 17.0007 19V22.764C17.0006 23.0743 16.9284 23.3804 16.7897 23.658L15.6197 26H28.3827L27.2127 23.658C27.0736 23.3805 27.001 23.0744 27.0007 22.764V19C27.0007 17.6739 26.4739 16.4021 25.5362 15.4645C24.5985 14.5268 23.3267 14 22.0007 14Z",
    fill: "#F7A703"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.083aae16293e1c888f25298193e17d71.svg";
export { ForwardRef as ReactComponent };